import React, { memo } from "react";
import PT from "prop-types";
import * as S from "./styled";
import { useScrollButtons } from "@/hooks/useScrollButtons";
import { CircleButton } from "_c/button";
import AngleRightIcon from "_c/icon/AngleRight";
import Filter from "./Filter";
import { SEARCH_NS as baseNs } from "@/i18n/ns";

const ns = `${baseNs}:inline_filters`;
const InlineFilters = ({ t, query, params }) => {
  const { visibleButtons, goNext, ref } = useScrollButtons();
  if (!params?.spec) return null;
  return (
    <div
      css={`
        position: relative;
      `}
    >
      {visibleButtons.right && (
        <CircleButton
          light
          css={`
            position: absolute;
            z-index: 2;
            top: 10px;
            right: 0;
          `}
          onClick={goNext}
        >
          <AngleRightIcon color="black" />
        </CircleButton>
      )}
      <S.Wrap ref={ref}>
        <Filter
          title={t(`${ns}.saloon`)}
          query={query}
          params={params}
          queryKey="at_saloon"
        />
        <Filter
          title={t(`${ns}.home`)}
          query={query}
          params={params}
          queryKey="at_home"
        />
        <Filter
          title={t(`${ns}.road`)}
          query={query}
          params={params}
          queryKey="the_road"
        />
        <Filter
          title={t(`${ns}.discounts`)}
          query={query}
          params={params}
          queryKey="discounts"
        />
        <Filter
          title={t(`${ns}.price`)}
          query={query}
          params={params}
          queryKey="price"
        />
        <Filter
          title={t(`${ns}.model`)}
          query={query}
          params={params}
          queryKey="model_search"
        />
        <Filter
          title={t(`${ns}.rate`)}
          query={query}
          params={params}
          queryKey="rate"
        />
      </S.Wrap>
    </div>
  );
};
InlineFilters.propTypes = {
  query: PT.object.isRequired,
  params: PT.object.isRequired,
  t: PT.func.isRequired,
};

export default memo(InlineFilters);
